import React from 'react';
import HeadersNonAuth from '../../components/base/HeadersNonAuth';

const OptionsStrategies = () => {
  return (
    <div className="bg-[#0b0d2a] text-white">
      <HeadersNonAuth />
      <br />
      <br />
      <div
        className="relative bg-cover bg-center h-64 flex items-center justify-center"
        style={{ backgroundImage: "url('/headers-landing.png')" }}
      >
        <h1 className="text-4xl font-bold text-white drop-shadow-md">Options Strategies</h1>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-10 space-y-6">
        <p className="mb-4">
          There are hundreds of ways to use Options in a portfolio as both the buyer and seller of options. Each strategy may be used for a bullish or bearish outlook on the underlying security.
        </p>

        <div className="space-y-8">
          <div>
            <h2 className="text-2xl font-semibold mb-4">Basic Options Strategies</h2>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Long Call</li>
              <li>Long Put</li>
              <li>Covered Call</li>
              <li>Protective Put</li>
              <li>Bull Call Spread</li>
              <li>Bear Put Spread</li>
              <li>Iron Condor</li>
              <li>Butterfly Spread</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4">Advanced Options Strategies</h2>
            <ul className="list-disc list-inside mb-4 space-y-2">
              <li>Straddle</li>
              <li>Strangle</li>
              <li>Calendar Spread</li>
              <li>Diagonal Spread</li>
              <li>Ratio Spread</li>
              <li>Backspread</li>
              <li>Jade Lizard</li>
              <li>Iron Butterfly</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-semibold mb-4">Risk Management</h2>
            <p className="mb-4">
              Each options strategy has its own risk profile and potential reward. It's important to understand the maximum loss, maximum gain, and break-even points before entering any options trade.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OptionsStrategies; 